import { cn } from '~/utils/cn';

type CommandBadgeProps = {
	className?: string;
	command?: string[];
	shouldShow?: boolean;
};

export const CommandBadge = ({ className, command, shouldShow: _shouldShow }: CommandBadgeProps) => {
	if (!command) {
		return null;
	}

	const keys = command
		.map((key) => {
			if (key === 'control') {
				return 'Ctrl';
			} else if (key === 'Meta') {
				return 'Cmd';
			} else {
				return key.toUpperCase();
			}
		})
		.join(' + ');

	return (
		<kbd
			className={cn(
				'fixed z-110 h-5 select-none items-center shadow-lg',
				'left-12',
				'text-foreground',
				'group-focus-within:left-36 group-hover:left-36',
				'pointer-events-none',
				'rounded bg-card',
				'border border-border',
				'px-1.5 font-medium font-mono text-[10px] opacity-100',
				'transition-all duration-300 ease-in-out',
				className,
			)}
		>
			<span className="whitespace-nowrap text-xs">{keys}</span>
		</kbd>
	);
};
